import { Alert, Link } from 'omakase';
import { Box } from '@material-ui/core';
import { FC } from 'react';
import { IconLock } from '@tock/icons';

const ResyLinkedAccountBanner: FC = () => (
  <Alert severity="basic" icon={<IconLock />} data-testid="resy-linked-account-banner">
    Email and phone are managed through your linked Resy account and can&apos;t be edited here. To
    make updates, please update your information in Resy.
    <Box mt={1}>
      <Link href="https://resy.com" target="_blank" rel="noopener noreferrer" underline="always">
        Go to Resy.com ↗
      </Link>
    </Box>
  </Alert>
);

export default ResyLinkedAccountBanner;
